import api from '../index';

const uploadFile = (propertyAssetId: string, body: any) => {
    return api.post(`/propertyassetpagesummary/${propertyAssetId}/files`, body);
};
const PropertyAssetPageSummaryApi = {
    uploadFile,
};
export default PropertyAssetPageSummaryApi;
